import { useQuery } from '@tanstack/react-query';
import api from '../login/axiosInstance';

export default function useMembers(token) {
  return useQuery({
    queryKey: ['users', token], enabled: !!token, refetchInterval: 60000,
    queryFn: async ({ signal }) => {
      const response = await api.get('/api/users', { signal, timeout: 15000 });
      if (!Array.isArray(response.data) || response.data.some(user => !user || typeof user.username !== 'string')) {
        throw new Error('The server returned an unexpected member list. Reload the page and try again.');
      }
      return response.data;
    },
  });
}
